import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/auth/use_auth'

/**
 * ダッシュボードからの認証付き遷移を処理するページ
 */
const TokenExchangePage: React.FC = () => {
  const navigate = useNavigate()
  const { loginWithToken, isAuthenticated } = useAuth()

  useEffect(() => {
    exchangeToken()
  }, [])

  const exchangeToken = async () => {
    // URLパラメータからトークン情報を取得
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    const key = params.get('key')
    const userId = params.get('user_id')

    // ログイン済みの場合はダッシュボードへ遷移
    if (isAuthenticated) {
      navigate('dashboard')
    }

    // パラメータが不足している場合はエラー
    if (!token || !key || !userId) {
      navigate('/')
      return
    }

    const isSuccess = await loginWithToken({
      token,
      key,
      userId,
    })
    if (isSuccess) {
      navigate('/dashboard')
    } else {
      navigate('/')
    }
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">認証処理中...</p>
        </div>
      </div>
    </div>
  )
}

export default TokenExchangePage
